export interface ProductsInfoModel {
  productCount: number;
  statusActive: number;
  statusConcept: number;
  statusDropped: number;
  versionCount: number;
}

export class ProductsInfo implements ProductsInfoModel {
  productCount = -1;
  statusActive = -1;
  statusConcept = -1;
  statusDropped = -1;
  versionCount = -1;

  constructor(dto?: ProductsInfoModel) {
    if (!dto) {
      return;
    }
    this.productCount = dto.productCount;
    this.statusActive = dto.statusActive;
    this.statusConcept = dto.statusConcept;
    this.statusDropped = dto.statusDropped;
    this.versionCount = dto.versionCount;
  }
}
